module.exports = __webpack_public_path__ + "static/assets/3a2a8e672237477a58d47bdd58579716.svg";